
let language = {
    PRODUCT_PROPERTY_FORM_ISSUE: "产品属性表单错误",
    PRODUCT_PROPERTY_FORM_ISSUE_CONTENT: "产品属性表单错误,请您稍后重试，如果问题仍然存在，请联系我们{{supportmail}}",
    PRODUCT_PROPERTY_FORM_ISSUE_108000061: "未能查询到相应的属性表单地址。",
    PRODUCT_PROPERTY_FORM_ISSUE_249962968:"在尝试加载产品属性表单时：'window'对象未定义。",
    PRODUCT_PROPERTY_FORM_ISSUE_249962969:"在尝试加载产品属性表单时: 无权限。",
    PRODUCT_PROPERTY_FORM_ISSUE_249962976: "在尝试加载产品属性表单时:请求超时。",
    PRODUCT_PROPERTY_FORM_ISSUE_251113501: "初始化产品属性表单失败。",
    PRODUCT_PROPERTY_FORM_ISSUE_251113554: "加载产品属性表单时出错了。",
    PRODUCT_PROPERTY_FORM_ISSUE_251113554_BY_EVENTID: "加载产品属性表单时出错了。 EventId:{{eventId}}",
    PRODUCT_PROPERTY_FORM_ISSUE_251216064: "产品属性表单自身校验失败。",
    PRODUCT_PROPERTY_FORM_ISSUE_251216800: "属性表单创建propertyModel异常。",
    PRODUCT_PROPERTY_FORM_ISSUE_251216855: "属性表单获取属性keyValue异常。",
    PRODUCT_PROPERTY_FORM_ISSUE_251216855_BY_EVENTID: "属性表单获取属性keyValue异常。 EventId:{{eventId}}",
    PRODUCT_PROPERTY_FORM_ISSUE_251217152: "产品属性表单不正确。",
    PRODUCT_PROPERTY_FORM_ISSUE_251219155: "产品属性表单创建SKU产品失败。",
};

export {language};